import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalLoaderService } from 'src/app/shared/components/global-loader.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: GlobalLoaderService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
    return next.handle(request)
      .pipe(catchError((err) => {
        this.loaderService.hide()
        return err;
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        return evt;
      }));
  }
}
